import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

import ApiGatewayLayer from '../components/ApiGatewayLayer';



const ApiKeyPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Api-Keys" />

        {/* PaymentGatewayLayer */}
        <ApiGatewayLayer />

      </MasterLayout>

    </>
  );
};

export default ApiKeyPage; 
